import { render } from "./CopySuccessModal.vue?vue&type=template&id=13a4356e&scoped=true"
import script from "./CopySuccessModal.vue?vue&type=script&lang=js"
export * from "./CopySuccessModal.vue?vue&type=script&lang=js"

import "./CopySuccessModal.vue?vue&type=style&index=0&id=13a4356e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a4356e"]])

export default __exports__